/* eslint-disable no-console */
import { HttpClient, HttpContext } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { HELIOS_COMMAND_HTTP_TOKEN } from '@helios/utils'
import { Observable } from 'rxjs'
import { BulkActivateExternalData } from '../../models/bulkActivateExternalData.model'
import { BulkActivateExternalDataService } from './bulkActivateExternalData.service'

const EXTERNAL_FILE_MANAGER_HOST = `helios-external-overview`
export const BULK_NEWER_EXTERNAL_DATA_URL = `${EXTERNAL_FILE_MANAGER_HOST}/bulkActivateExternalData`

@Injectable({
  providedIn: 'root',
})
export class HttpBulkActivateExternalDataService extends BulkActivateExternalDataService {
  constructor(private readonly httpClient: HttpClient) {
    super()
  }

  bulkActivateNewerData(
    beginReconDate: string,
    endReconDate: string,
    accountIds: string,
    dataSourceType: string,
  ): Observable<void> {
    const payload: BulkActivateExternalData = {
      beginReconDate: beginReconDate,
      endReconDate: endReconDate,
      accountIds: accountIds.split(',').map(Number),
      dataSourceTypes: dataSourceType,
    }
    const options = {
      context: new HttpContext().set(HELIOS_COMMAND_HTTP_TOKEN, true),
    }
    return this.httpClient.post<void>(
      BULK_NEWER_EXTERNAL_DATA_URL,
      payload,
      options,
    )
  }
}
